import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 建具自動生成確認ダイアログ
 * 3D遷移時に、建具が一つもない場合に表示
 */
class ConfirmGenerateFittingsDialog extends Dialog {
  /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);
    // ダイアログのコンテンツ生成
    const id = 'confirmGenerateFittingsDialog';
    let title = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en': title = 'Automatic joinery generation'; break;
      default: title = '建具自動生成'; break;
    }

    let contents = '<div class="confirmGenerateFittings">\n';
    contents += '<span class="jp">建具が配置されていません。<br>全ての階に建具を自動生成しますか？</span><span class="en">No fittings placed.<br>Would you like to run the auto fitting generation?</span>';
    contents += '</div>\n';

    let footer = '<button value="true"><span class="jp">はい</span><span class="en">Yes</span></button>';
    footer += '<button><span class="jp">いいえ</span><span class="en">No</span></button>';

    this.createDialog(id, title, contents, footer);

    this.viewObj.querySelectorAll('button').forEach((element) => {
      element.addEventListener('click', this.btnEventHandler);
    });
  }

    /**
     * ボタンがクリックされた
     */
    btnEventHandler = (e) => {
      this.close();
      e.preventDefault();
      if ((e.currentTarget).value) {
        marietta.webcad.WebCADGlobal.cadAPIManager.generateFittings(() => {
          marietta.webcad.WebCADGlobal.dimensionMenu.checkModelParam(marietta.webcad.WebCADGlobal.dimensionMenu.changeMode3D);
        }, true);
      } else {
        marietta.webcad.WebCADGlobal.dimensionMenu.checkModelParam(marietta.webcad.WebCADGlobal.dimensionMenu.changeMode3D);
      }
    }

  // /**
  // * model_paramの有無判別と処理
  // */
  // checkModelParamExist = () =>{
  //     if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.modelParam) {
  //         marietta.webcad.WebCADGlobal.buildStyleManager.getList();
  //     } else {
  //         marietta.webcad.WebCADGlobal.dimensionMenu.changeMode3D();
  //     }
  //     this.close();
  // }
}
export default ConfirmGenerateFittingsDialog;
